import React from 'react';
import './DownloadPage.css';
import { Container } from 'react-bootstrap'
import SimpleHero from './components/SimpleHero/SimpleHero';
import appleBadge from './assets/images/apple.png';
import googleBadge from './assets/images/google.png';
import mobileImg from './assets/images/Mobile.png';

const DownloadPage = () => {
  return (
    <div>
      <SimpleHero
        title="Get the GN Bank app"
        subtitle="Check balances, transfer money, and deposit checks from anywhere."
        primaryLabel="Learn more"
        primaryHref="/MobileBanking"
        variant="sofi"
        imageSrc={mobileImg}
        imageAlt="GN Bank mobile app"
        imageOn="right"
        tiltImage
        badges={["iOS & Android","Secure","Free"]}
      />

      <section className="section">
        <div className="gn-container download-buttons">
          <a
            href="https://apps.apple.com/us/app/gn-bank/id1593719853?itsct=apps_box_link&itscg=30200"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store"
          >
            <img src={appleBadge} alt="Download on the App Store" className="store-badge" />
          </a>
          <a
            href="https://play.google.com/store/search?q=GN%20Bank&c=apps"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get it on Google Play"
          >
            <img src={googleBadge} alt="Get it on Google Play" className="store-badge" />
          </a>
        </div>
      </section>

      <section className="section">
        <Container>
          <div className="pwa-info text-center">
            <p className="card-text">Prefer the web? Add GN Bank to your home screen.</p>
            <button className="btn btn-gn-secondary" onClick={handleAddToHomeScreen}>Add to Home Screen</button>
          </div>
        </Container>
      </section>
    </div>
  );
};

// Add PWA "Add to Home Screen" prompt functionality
const handleAddToHomeScreen = () => {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    alert('You have already added the app to your home screen!');
  } else {
    if (window.deferredPrompt) {
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        window.deferredPrompt = null;
      });
    }
  }
};

export default DownloadPage;
